import type { Column } from '@tanstack/react-table'
import { ArrowDownIcon, ArrowUpDown, ArrowUpIcon } from 'lucide-react'
import { cn } from '@/shared/lib/utils'

interface DataTableColumnHeaderProps<TData> {
  column: Column<TData>
  name: string
  className?: string
  sortable?: boolean
}

export function DataTableColumnHeader<TData>({
  name,
  column,
  className,
  sortable = true
}: DataTableColumnHeaderProps<TData>) {
  if (!sortable) {
    return (
      <span className={cn('text-xs font-medium text-muted-foreground', className)}>{name}</span>
    )
  }

  return (
    <button
      type="button"
      className={cn(
        'group flex h-8 w-full touch-manipulation cursor-pointer items-center gap-1 select-none text-left',
        'text-xs font-medium text-muted-foreground',
        'hover:text-foreground transition-colors duration-75',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-inset',
        className
      )}
      onClick={column.getToggleSortingHandler()}
    >
      <span>{name}</span>
      {column.getIsSorted() === 'desc' ? (
        <ArrowDownIcon aria-hidden="true" className="h-3 w-3 shrink-0" />
      ) : column.getIsSorted() === 'asc' ? (
        <ArrowUpIcon aria-hidden="true" className="h-3 w-3 shrink-0" />
      ) : (
        <ArrowUpDown
          aria-hidden="true"
          className="h-3 w-3 shrink-0 opacity-0 transition-opacity group-hover:opacity-40 group-focus-visible:opacity-40"
        />
      )}
    </button>
  )
}
